import { render } from "./RegionImagesEdit.vue?vue&type=template&id=9dc5c380"
import script from "./RegionImagesEdit.vue?vue&type=script&lang=js"
export * from "./RegionImagesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__